import * as Layout from '#/components/Layout'

export function Ios26CrashRegressionScreen() {
  return <Layout.Screen testID="ios26CrashRegressionUnavailable" />
}
